var exports = {
  "kL": "FriendsSkeleton.module__container___UjYxdm",
  "Em": "FriendsSkeleton.module__mainColumn___UjYxdm",
  "wx": "FriendsSkeleton.module__header___UjYxdm",
  "BS": "FriendsSkeleton.module__headerLeftSection___UjYxdm",
  "Gv": "FriendsSkeleton.module__backButton___UjYxdm",
  "cZ": "FriendsSkeleton.module__backButtonMobile___UjYxdm",
  "LD": "FriendsSkeleton.module__headerLeft___UjYxdm",
  "cP": "FriendsSkeleton.module__titleSection___UjYxdm",
  "yF": "FriendsSkeleton.module__divider___UjYxdm",
  "me": "FriendsSkeleton.module__tabsWrapper___UjYxdm",
  "VD": "FriendsSkeleton.module__tabsInner___UjYxdm",
  "IE": "FriendsSkeleton.module__headerRight___UjYxdm",
  "Qs": "FriendsSkeleton.module__content___UjYxdm",
  "sf": "FriendsSkeleton.module__searchWrapper___UjYxdm",
  "MJ": "FriendsSkeleton.module__tabBody___UjYxdm",
  "p_": "FriendsSkeleton.module__list___UjYxdm",
  "p$": "FriendsSkeleton.module__emptyState___UjYxdm",
  "AI": "FriendsSkeleton.module__emptyStateIcon___UjYxdm",
  "vo": "FriendsSkeleton.module__emptyStateTitle___UjYxdm",
  "F9": "FriendsSkeleton.module__emptyStateSubtitle___UjYxdm",
  "Gf": "FriendsSkeleton.module__sectionTitle___UjYxdm" + " " + __webpack_require__(685469)["Gf"],
  "Ge": "FriendsSkeleton.module__rows___UjYxdm" + " " + __webpack_require__(685469)["f5"],
  "GF": "FriendsSkeleton.module__rowsWithMargin___UjYxdm" + " " + __webpack_require__(685469)["v2"],
  "nM": "FriendsSkeleton.module__row___UjYxdm",
  "z2": "FriendsSkeleton.module__rowInfo___UjYxdm",
  "pt": "FriendsSkeleton.module__rowDetails___UjYxdm",
  "hj": "FriendsSkeleton.module__rowNameBand___UjYxdm",
  "f": "FriendsSkeleton.module__rowSubtextBand___UjYxdm",
  "cm": "FriendsSkeleton.module__rowActions___UjYxdm",
  "pz": "FriendsSkeleton.module__sidebar___UjYxdm",
  "aN": "FriendsSkeleton.module__sidebarHeader___UjYxdm",
  "wp": "FriendsSkeleton.module__sidebarContent___UjYxdm",
  "rF": "FriendsSkeleton.module__sidebarEmptyState___UjYxdm",
  "sM": "FriendsSkeleton.module__sidebarEmptyTitle___UjYxdm",
  "iZ": "FriendsSkeleton.module__sidebarEmptyDescription___UjYxdm",
  "KC": "FriendsSkeleton.module__sidebarEmptyDescriptionLine___UjYxdm",
  "H4": "FriendsSkeleton.module__activeNowCard___UjYxdm",
  "zO": "FriendsSkeleton.module__activeNowContextGroup___UjYxdm",
  "vA": "FriendsSkeleton.module__activeNowStatus___UjYxdm",
  "Ud": "FriendsSkeleton.module__activeNowContext___UjYxdm",
  "dr": "FriendsSkeleton.module__activeNowParticipants___UjYxdm",
  "$Q": "FriendsSkeleton.module__activeNowAction___UjYxdm",
};

module.exports = exports;
